import { ConfigSubdomain } from "@/configuration/tenant-ids";
export * from "@/configuration/document-mappings/types";

import type { DocumentMappingRegistry } from "@/configuration/document-mappings/types";
import { APEX_MAPPINGS } from "@/configuration/groups/apex/generated/document-mappings";
import { AUTONOMY_MAPPINGS } from "@/configuration/groups/autonomy/generated/document-mappings";
import { BALANCE_HEALTH_MAPPINGS } from "@/configuration/groups/balance-health/generated/document-mappings";
import { COUG_MAPPINGS } from "@/configuration/groups/coug/generated/document-mappings";
import { ENTP_MAPPINGS } from "@/configuration/groups/entpartners/document-mappings";
import { FCC_MAPPINGS } from "@/configuration/groups/fcc/generated/document-mappings";
import { HEARTPLACE_MAPPINGS } from "@/configuration/groups/heartplace/generated/document-mappings";
import { MENT_MAPPINGS } from "@/configuration/groups/ment/document-mappings";
import { PACESETTER_MAPPINGS } from "@/configuration/groups/pacesetter/generated/document-mappings";
import { PA_EAST_MAPPINGS } from "@/configuration/groups/pediatricassociates-east/generated/document-mappings";
import { PINNACLE_MAPPINGS } from "@/configuration/groups/pinnacle/generated/document-mappings";
import { PPCP_MAPPINGS } from "@/configuration/groups/ppcp/generated/document-mappings";
import { SIENT_MAPPINGS } from "@/configuration/groups/sient/generated/document-mappings";
import { TEXAS_HEART_SOUTH_HEART_MAPPINGS } from "@/configuration/groups/south-heart/generated/document-mappings";
import { STRIDECARE_MAPPINGS } from "@/configuration/groups/stridecare/generated/document-mappings";
import { TRICITY_MAPPINGS } from "@/configuration/groups/tco/generated/document-mappings";
import { USHV_CCOH_MAPPINGS } from "@/configuration/groups/ushv-ccoh/generated/document-mappings";
import { USHV_FORTWORTH_MAPPINGS } from "@/configuration/groups/ushv-fortworth/generated/document-mappings";
import { USHV_MCA_MAPPINGS } from "@/configuration/groups/ushv-mca/generated/document-mappings";
import { USHV_MKC_MAPPINGS } from "@/configuration/groups/ushv-mkc/generated/document-mappings";
import { USHV_PIMA_MAPPINGS } from "@/configuration/groups/ushv-pima/generated/document-mappings";
import { USRC_CPS_MAPPINGS } from "@/configuration/groups/usrc-cps/generated/document-mappings";
import { VPS_MAPPINGS } from "@/configuration/groups/vps/generated/document-mappings";

export {
  APEX_MAPPINGS,
  AUTONOMY_MAPPINGS,
  BALANCE_HEALTH_MAPPINGS,
  COUG_MAPPINGS,
  ENTP_MAPPINGS,
  FCC_MAPPINGS,
  MENT_MAPPINGS,
  PINNACLE_MAPPINGS,
  HEARTPLACE_MAPPINGS,
  PACESETTER_MAPPINGS,
  PA_EAST_MAPPINGS,
  PPCP_MAPPINGS,
  SIENT_MAPPINGS,
  TEXAS_HEART_SOUTH_HEART_MAPPINGS,
  STRIDECARE_MAPPINGS,
  TRICITY_MAPPINGS,
  USHV_CCOH_MAPPINGS,
  USHV_FORTWORTH_MAPPINGS,
  USHV_MCA_MAPPINGS,
  USHV_MKC_MAPPINGS,
  USHV_PIMA_MAPPINGS,
  USRC_CPS_MAPPINGS,
  VPS_MAPPINGS,
};

export function getMappingsForGroup(group: string): DocumentMappingRegistry {
  switch (group) {
    case ConfigSubdomain.APEX:
      return APEX_MAPPINGS;
    case ConfigSubdomain.COUG:
      return COUG_MAPPINGS;
    case ConfigSubdomain.ENT_PARTNERS:
      return ENTP_MAPPINGS;
    case ConfigSubdomain.ENT_PARTNERS_MENT:
      return MENT_MAPPINGS;
    case ConfigSubdomain.PINNACLE:
      return PINNACLE_MAPPINGS;
    case ConfigSubdomain.FCC:
      return FCC_MAPPINGS;
    case ConfigSubdomain.SIENT:
      return SIENT_MAPPINGS;
    case ConfigSubdomain.VALERIE:
      return PINNACLE_MAPPINGS; // Valerie uses Pinnacle mappings for now
    case "demo":
      return PINNACLE_MAPPINGS;
    case ConfigSubdomain.HEARTPLACE:
      return HEARTPLACE_MAPPINGS;
    case ConfigSubdomain.AUTONOMY:
      return AUTONOMY_MAPPINGS;
    case ConfigSubdomain.BALANCE_HEALTH:
      return BALANCE_HEALTH_MAPPINGS;
    case ConfigSubdomain.STRIDECARE:
      return STRIDECARE_MAPPINGS;
    case ConfigSubdomain.TRICITY:
      return TRICITY_MAPPINGS;
    case ConfigSubdomain.TEXAS_HEART_SOUTH_HEART:
      return TEXAS_HEART_SOUTH_HEART_MAPPINGS;
    case ConfigSubdomain.USHV_CCOH:
      return USHV_CCOH_MAPPINGS;
    case ConfigSubdomain.USHV_FORTWORTH:
      return USHV_FORTWORTH_MAPPINGS;
    case ConfigSubdomain.USHV_MCA:
      return USHV_MCA_MAPPINGS;
    case ConfigSubdomain.USHV_MKC:
      return USHV_MKC_MAPPINGS;
    case ConfigSubdomain.USHV_PIMA:
      return USHV_PIMA_MAPPINGS;
    case ConfigSubdomain.USRC_CPS_AK:
    case ConfigSubdomain.USRC_CPS_CO:
      return USRC_CPS_MAPPINGS;
    case ConfigSubdomain.VPS:
      return VPS_MAPPINGS;
    case ConfigSubdomain.PA_EAST_REGION:
      return PA_EAST_MAPPINGS;
    case ConfigSubdomain.PACESETTER:
      return PACESETTER_MAPPINGS;
    case ConfigSubdomain.PPCP:
      return PPCP_MAPPINGS;
    default:
      throw new Error(`No document mappings defined for group: ${group}`);
  }
}
